import { useState, useEffect } from "react";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import SubHeader from "../../../../Components/ComponentsIndustry/SubHeader";
import axios from "axios";
import ModalVisitCustomer from "../../../../Components/ComponentsIndustry/ModalVisitCustomer";
import {
  Container,
  SizeContainer,
  TitleContainer,
  AddButton,
  TitleContent,
  VisitContainer,
  InternalVisitContainer,
  AddContainer,
  Signal,
  AddVisit,
  MainContainer,
  AvailabelStock,
  SubTitle,
  RequestContainer,
  FirstRequestContainer,
  ButtonContainer,
  SecondRequestContainer,
  ButtonRequest,
  FirstMarketngContainer,
  MarketngContainer,
  CountMarketngContainer,
  TotalContainer,
  CountdownContainer,
  Total,
  Icon,
} from "../style";
import { useUser } from "../../../../providers/UserContext";
import { useFries } from "../../../../providers/FriesContext";
import { useCommercialSales } from "../../../../providers/CommercialSalesContext";
import Countdown from 'react-countdown';

const ToolsCommercialFries = () => {

  const {infoFries, getFriesStock} = useFries()
  const {currentNegociation, timer, intervalId, setIntervalId, setStatusContext,  getCompaniesNotScheduled , getCompaniesScheduled, finishedTimeVisita, scheduleNewVisit, companiesVisitScheduled,companies, setCurrentNegociation, getCurrentNegociation,statusContext, setCurrentScheduling, currentScheduling, setCurrentVisita, currentVisita} = useCommercialSales()
  const [showModal, setShowModal] = useState(false)

  const [inCash, setInCash] = useState(false);
  const [thirtyDays, setThirtyDays] = useState(false);
  const [showAllCompanies, setShowAllCompanies] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [info, setInfo] = useState([])
  const [showPedido, setShowPedido] = useState(false)
  const [caixas, setCaixas] = useState('')
  const [precoMedio, setPrecoMedio] = useState(0)
  const [status, setStatus] = useState('')
  const [error, setError] = useState('')
  const [encarteTotal, setEncarteTotal] = useState(0)
  const [encartePrice, setEncartePrice] = useState(0)
  const [tvTotal, setTvTotal] = useState(0)
  const [tvPrice, setTvPrice] = useState(0)
  const [radioTotal, setRadioTotal] = useState(0)
  const [radioPrice, setRadioPrice] = useState(0)
  const [repositoraPrice, setRepositoraPrice] = useState(0)
  const [repositoraTotal, setRepositoraTotal] = useState(0)
  const [demonstradoraPrice, setDemonstradoraPrice] = useState(0)
  const [demonstradoraTotal, setDemonstradoraTotal] = useState(0)
  const [total, setTotal] = useState(0)

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })
 
  function setAllStates(responseData) {

    responseData?.itens?.forEach(element => {

      if(element.produto.produto === 10) {
        element?.preco ? setPrecoMedio(element.preco) : setPrecoMedio(0)
        setCaixas(element?.quantidade)
        element?.encarteTotal ? setEncartePrice(element?.encarteTotal) : setEncartePrice(0)
        setEncarteTotal(element?.encarteQuantidade)
        element?.repositoraTotal ? setRepositoraPrice(element?.repositoraTotal) : setRepositoraPrice(0)
        setRepositoraTotal(element?.repositoraQuantidade)
        element?.demonstradoraTotal ? setDemonstradoraPrice(element?.demonstradoraTotal) : setDemonstradoraPrice(0)
        setDemonstradoraTotal(element?.demonstradoraQuantidade)
        element?.tvTotal ? setTvPrice(element?.tvTotal) : setTvPrice(0)
        setTvTotal(element?.tvQuantidade)
        element?.radioTotal ? setRadioPrice(element?.radioTotal) : setRadioTotal(0)
        setRadioTotal(element?.radioQuantidade)

      }

    });

  }

  function handleClickedVisita(market) {

    api.get(`/api/visita/listarNegociacoes/${market.visita}`)
    .then(response => {

      setCurrentVisita(market)
      setCurrentScheduling(response?.data[0])
      setCurrentNegociation(response?.data[0]?.itens ? response?.data[0]?.itens : [])
      const responseData = response?.data[0]
      setAllStates(responseData)
      setStatusContext(response?.data[0]?.status)
      setShowPedido(true)


    })

  }

  const renderer = ({ minutes, seconds }) => {

    // if (Number(minutes) === 0 && Number(seconds) === 0) {

    // finishedTimeVisita()

    // }
    // Render a countdown
    return <CountdownContainer>{minutes}:{seconds}</CountdownContainer>;
  
  };

  function sendOffer() {

    const data = {
      "demonstradoraCusto": 3500 / 4,
      "demonstradoraQuantidade": demonstradoraTotal,
      "demonstradoraTotal": demonstradoraPrice,
      "encarteCusto": 1250,
      "encarteQuantidade": encarteTotal,
      "encarteTotal": encartePrice,
      "negociacaoItem": 0,
      "preco": precoMedio,
      "produto": {
        "produto": 10,
        "nome": "Batata"
      },
      "quantidade": caixas,
      "total": precoMedio,
      "radioCusto": 1500,
      "radioQuantidade": radioTotal,
      "radioTotal": radioPrice,
      "repositoraCusto": 800,
      "repositoraQuantidade": repositoraTotal,
      "repositoraTotal": repositoraPrice,
      "tvCusto": 2500,
      "tvQuantidade": tvTotal,
      "tvTotal": tvPrice
    }

    if (currentNegociation?.some(item => {
      return item.produto.produto === data.produto.produto
    })) {
      const addArray = currentNegociation.filter(item => item.produto.produto !== 10)
      addArray.push(data)
      setCurrentNegociation(addArray)
      setShowModal(true)
    } else {
      console.log(currentNegociation)
      setCurrentNegociation(currentNegociation => [...currentNegociation, data])
      setShowModal(true)
    }

  }

  const handleDeadline = (sub) => {
    switch (sub) {
      case "inCash":
        setInCash(true);
        setThirtyDays(false);
        break;
      case "thirtyDays":
        setInCash(false);
        setThirtyDays(true);
        break;
      default:
        break;
    }
  };

  const handleCaixas = (e) => {

    setCaixas(e.target.value)

    const calPrice = (e.target.value * infoFries.preco)

    setPrecoMedio(calPrice)
  }

  const handleMarketingPrice = (e, setTotalMarketing, setState, fator) => {

    setTotalMarketing(e.target.value)

    const calPrice = (e.target.value * fator)

    setState(calPrice)
  }

  useEffect(() => {
    
    getCompaniesScheduled()
    getCompaniesNotScheduled()

    var intervalo = window.setInterval(callsVisitas, 10000);

      function callsVisitas() {
        
        // clearInterval(intervalo);
        getCompaniesScheduled()
        getCompaniesNotScheduled()
        
      } 
      return () => clearInterval(intervalo);
    
  }, [])

  useEffect(() => {

    if (statusContext) {

      if(statusContext === "A") {
        setShowPedido(true)
        setStatus("Aguardando Supermercado")
      } else if (statusContext === "I") {
        setShowPedido(true)
        setStatus("Aguardando")
      }
      else if (statusContext === "P") {
        setShowPedido(true)
        setStatus("Aceito")
      }
      else if (statusContext === "R") {
        setShowPedido(true)
        setStatus("Rejeitado")
      } else {
        setShowPedido(true)
        setStatus("Faça uma proposta")
        console.log("aqui")
        if (currentNegociation?.some(item => {
          return item.produto.produto === 10
        })) {
          currentNegociation.forEach(element => {
  
            if(element.produto.produto === 10) {
              setPrecoMedio(element.preco)
              setCaixas(element.quantidade) 
            }
  
          });
          
        }
      }
      
      if (statusContext === "I") {
        clearInterval(intervalId);
        setIntervalId(0);
        return;
      }

    }

  }, [statusContext])

  // useEffect(() => {

  //   if (statusContext === "I") {
  //     clearInterval(intervalId);
  //     setIntervalId(0);
  //     return;
  //   }

  // }, [statusContext]) 

  useEffect(() => {

    if(currentScheduling)
    setAllStates(currentScheduling)

  }, [currentScheduling])

  const handleResult = () => {

    if(isNaN(parseFloat(precoMedio) + parseFloat(encartePrice) + parseFloat(demonstradoraPrice) + parseFloat(tvPrice) + parseFloat(radioPrice) + parseFloat(repositoraPrice))) {
      return 0
    } else {
      return parseFloat(precoMedio) + parseFloat(encartePrice) + parseFloat(demonstradoraPrice) + parseFloat(tvPrice) + parseFloat(radioPrice) + parseFloat(repositoraPrice)
    }
  }

  useEffect(() => {

    getFriesStock()

  }, [])

  return (
    <Container>
      {/* <ModalVisitCustomer/> */}
      {
        showModal &&
        <ModalVisitCustomer isIndustry={true} setShowModal={setShowModal} />

      }
      <SizeContainer>
        <HeaderTools
          pathImg="./images/commercial_button.svg"
          title="Comercial"
          subTitle="(Vendas e Contato com Mercados)"
          style={["", "", "", "selection", ""]}
        />
        <TitleContainer>
          <TitleContent>
            <img src="./images/partnership.svg" alt="partnership" />
            Agendar Visitas
          </TitleContent>
          <AddButton onClick={() => {
            setShowAllCompanies(!showAllCompanies)
          }}>+</AddButton>
          <VisitContainer>
            {showAllCompanies &&
              companies.map((market, key) => {
                return <InternalVisitContainer key={key}>
                <img src="./images/market_basket.svg" alt="market_basket" />
                <p>{market.nome}</p>
                <AddContainer>
                  <Signal style={{
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    boxShadow: "0 0 10px 5px rgba(0, 0, 0, 0.1)"}}
                  />
                  <AddVisit onClick={() => scheduleNewVisit(market)}>+</AddVisit>
                </AddContainer>
              </InternalVisitContainer>
              })
            }
            {
              companiesVisitScheduled.map((market, key) => {
                return <InternalVisitContainer key={key}>
                <img src="./images/market_basket.svg" alt="market_basket" />
                <p>{market.supermercado.nome}</p>
                <AddContainer>
                  <Signal style={market.confirmada ?
                    {
                      backgroundColor: "#00a000",
                      boxShadow: "0 0 10px 5px rgba(1, 100, 1, 0.5)"
                    }
                    :
                    {
                      backgroundColor: "#ffd700",
                      boxShadow: "0 0 10px 5px rgba(255, 215, 0, 0.5)"
                    }
                  }
                  />
                  <AddVisit 
                  onClick={() => handleClickedVisita(market)}
                  >
                    +
                  </AddVisit>
                </AddContainer>
              </InternalVisitContainer>
              })
            }
          
            
          </VisitContainer>
          <TitleContent>Visitas agendadas</TitleContent>
        </TitleContainer>
        <SubHeader
          style={["", "", "", "selection", "selection"]}
          path1="toolsCommercialSausage"
          path2="toolsCommercialChicken"
          path3="toolsCommercialChickenCut"
          path4="toolsCommercialFries"
        />
        <MainContainer>
          <h2>
            Produção de <small>Batata</small> 
          </h2>
          <AvailabelStock>
            <h3>
              <img src="./images/productions.svg" alt="productions" /> Estoque
              Disponível
            </h3>
            <p>{infoFries.estoque}</p> <small>KG</small>
          </AvailabelStock>

          {
            currentVisita?.confirmada ?
              (
              <>
              <RequestContainer>
                <SubTitle>
                  <img src="./images/ticket.svg" alt="ticket" />
                  <div style={{marginTop: "30px"}}>Pedido de {currentVisita && currentVisita.supermercado.nome} <br/> ({status}) 
                  </div>
                  <div style={{marginTop: "5px"}}>
                    {
                      status !== "Aceito" ?
                      <Countdown renderer={renderer} 
                      date={new Date(timer)} 
                    /> : 
                    <></>
                    }
                  </div>
                </SubTitle>
                <FirstRequestContainer>
                  <div>
                    <small>Quantidade de Caixas</small>
                    <input value={caixas} onChange={(e) => handleCaixas(e)} type="number" placeholder="0" />
                  </div>
                  <p>
                    R$<input value={precoMedio} onChange={(e) => setPrecoMedio(e.target.value)} type="number" placeholder="0" /><img src="./images/box.svg" alt="box" />
                  </p>
                  <div className="buttons">
                    <ButtonContainer>
                      <p>á vista</p>
                      {inCash ? (
                        <button
                          className="checked"
                          onClick={() => handleDeadline("inCash")}
                        />
                      ) : (
                        <button onClick={() => handleDeadline("inCash")} />
                      )}
                    </ButtonContainer>
                    <ButtonContainer>
                      <p>30 dias</p>
                      {thirtyDays ? (
                        <button
                          className="checked"
                          onClick={() => handleDeadline("thirtyDays")}
                        />
                      ) : (
                        <button onClick={() => handleDeadline("thirtyDays")} />
                      )}
                    </ButtonContainer>
                  </div>
                </FirstRequestContainer>
                <SecondRequestContainer>
                </SecondRequestContainer>
              </RequestContainer>
          
          <SubTitle>
            <img src="./images/marketing.svg" alt="marketing" />
            Marketing e Promoção
          </SubTitle>
          <MarketngContainer>
            <FirstMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" type={"number"} value={repositoraTotal} onChange={(e) => handleMarketingPrice(e, setRepositoraTotal, setRepositoraPrice, 800)} />
                <p>Repositora</p>
                <small>3.200/mês</small>
                <div>
                  <input value={repositoraPrice} onChange={(e) => setRepositoraPrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" type={"number"} value={encarteTotal} onChange={(e) => handleMarketingPrice(e, setEncarteTotal, setEncartePrice, 1250)} />
                <p>Encarte</p>
                <small>5.000/mês</small>
                <div>
                  <input value={encartePrice} onChange={(e) => setEncartePrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" type={"number"} value={tvTotal} onChange={(e) => handleMarketingPrice(e, setTvTotal, setTvPrice, 2500)} />
                <p>TV</p>
                <small>10.000/mês</small>
                <div>
                  <input value={tvPrice} onChange={(e) => setTvPrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" type={"number"} value={radioTotal} onChange={(e) => handleMarketingPrice(e, setRadioTotal, setRadioPrice, 1500)} />
                <p>Rádio</p>
                <small>6.000/mês</small>
                <div>
                  <input value={radioPrice} onChange={(e) => setRadioPrice(e.target.value)} ></input> <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" type={"number"} value={demonstradoraTotal} onChange={(e) => handleMarketingPrice(e, setDemonstradoraTotal, setDemonstradoraPrice, 3500 / 4)} />
                <p>Demonstradora</p>
                <small>3.500/mês</small>
                <div>
                  <input value={demonstradoraPrice} onChange={(e) => setDemonstradoraPrice(e.target.value)} ></input> <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>
            </FirstMarketngContainer>
            <TotalContainer>
              <p>
                Total
                <small>Marketing e Pedido</small>
              </p>
              <div>
                R$ {handleResult()} <img src="./images/cifrao.svg" alt="cifrao" />
              </div>
            </TotalContainer>
          </MarketngContainer> 

          {
            statusContext !== "A" && statusContext !== "P" ?
            <ButtonRequest onClick={() => sendOffer()} style={{background: "#ffd700"}}>Enviar</ButtonRequest> :
            <></>
          }
          </>)
                :
              (
                <RequestContainer style={{color: "white", }}>
                  <h2>{error}</h2>
                </RequestContainer>
              )
          }

          
          {/* <SubTitle>
            <img src="./images/marketing.svg" alt="marketing" />
            Marketing e Promoção
          </SubTitle>
          <MarketngContainer>
            <FirstMarketngContainer>
              <CountMarketngContainer>
                <input placeholder="0" />
                <p>Demonstradora</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" />
                <p>Repositora</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" />
                <p>Encarte</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" />
                <p>TV</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" />
                <p>Rádio</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>

              <CountMarketngContainer>
                <input placeholder="0" />
                <p>Demonstradora</p>
                <small>1.000/mês</small>
                <div>
                  R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
                </div>
              </CountMarketngContainer>
            </FirstMarketngContainer>
            <TotalContainer>
              <p>
                Total
                <small>Marketing Produto</small>
              </p>
              <div>
                R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
              </div>
            </TotalContainer>
            <TotalContainer>
              <p>
                Total
                <small>Marketing Pedidos</small>
              </p>
              <div>
                R$0,00 <img src="./images/cifrao.svg" alt="cifrao" />
              </div>
            </TotalContainer>
          </MarketngContainer> */}
          {/* <Total>
            <Icon
              src="./images/commercial_button.svg"
              alt="commercial_button"
            />
            <div>
            <h3>Total</h3>
            <p>
              D$ 0,00<img src="./images/cifrao.svg" alt="cifrao" />
            </p>
            </div>
          </Total> */}
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default ToolsCommercialFries;
